/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProgramMaturityInitiativeRefDto
 */
export interface ProgramMaturityInitiativeRefDto {
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityInitiativeRefDto
     */
    initiativeId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityInitiativeRefDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityInitiativeRefDto
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof ProgramMaturityInitiativeRefDto
     */
    statusLabel?: string;
}

/**
 * Check if a given object implements the ProgramMaturityInitiativeRefDto interface.
 */
export function instanceOfProgramMaturityInitiativeRefDto(value: object): value is ProgramMaturityInitiativeRefDto {
    return true;
}

export function ProgramMaturityInitiativeRefDtoFromJSON(json: any): ProgramMaturityInitiativeRefDto {
    return ProgramMaturityInitiativeRefDtoFromJSONTyped(json, false);
}

export function ProgramMaturityInitiativeRefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProgramMaturityInitiativeRefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'initiativeId': json['initiativeId'] == null ? undefined : json['initiativeId'],
        'name': json['name'] == null ? undefined : json['name'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusLabel': json['statusLabel'] == null ? undefined : json['statusLabel'],
    };
}

export function ProgramMaturityInitiativeRefDtoToJSON(json: any): ProgramMaturityInitiativeRefDto {
    return ProgramMaturityInitiativeRefDtoToJSONTyped(json, false);
}

export function ProgramMaturityInitiativeRefDtoToJSONTyped(value?: ProgramMaturityInitiativeRefDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'initiativeId': value['initiativeId'],
        'name': value['name'],
        'status': value['status'],
        'statusLabel': value['statusLabel'],
    };
}

